import { isEmpty } from 'lodash-es'

import { customerStoryService } from '../../service/customer-story-service'
import { tap } from 'rxjs/operators'

export const namespace = 'CUSTOMER_STORY'

export const types = {
  GET_CUSTOMER_STORIES_MAIN: 'getCustomerStoriesMain',
  SET_CUSTOMER_STORIES_MAIN: 'setCustomerStoriesMain',
  GET_CUSTOMER_STORIES_INTRO: 'getCustomerStoriesIntro',
  SET_CUSTOMER_STORIES_INTRO: 'setCustomerStoriesIntro',
  GET_CUSTOMER_STORIES_DETAIL: 'getCustomerStoriesDetail',
  SET_CUSTOMER_STORIES_DETAIL: 'setCustomerStoriesDetail'
}

const state = {
  customerStoriesMain: [],
  customerStoriesIntro: [],
  customerStoriesDetail: []
}

const mutations = {
  [types.SET_CUSTOMER_STORIES_INTRO](state, payload) {
    state.customerStoriesIntro = payload
  },
  [types.SET_CUSTOMER_STORIES_MAIN](state, payload) {
    state.customerStoriesMain = payload
  },
  [types.SET_CUSTOMER_STORIES_DETAIL](state, payload) {
    state.customerStoriesDetail = payload
  }
}

const actions = {
  [types.GET_CUSTOMER_STORIES_INTRO]({ state, commit }, country) {
    if (isEmpty(state.customerStoriesIntro) == false) {
      return
    }

    return customerStoryService
      .getCustomerStoriesIntro$(country)
      .pipe(tap(customerStories => commit(types.SET_CUSTOMER_STORIES_INTRO, customerStories)))
      .toPromise()
  },
  [types.GET_CUSTOMER_STORIES_MAIN]({ state, commit }, country) {
    if (isEmpty(state.customerStoriesMain) == false) {
      return
    }

    return customerStoryService
      .getCustomerStoriesMain$(country)
      .pipe(tap(customerStories => commit(types.SET_CUSTOMER_STORIES_MAIN, customerStories)))
      .toPromise()
  },
  [types.GET_CUSTOMER_STORIES_DETAIL]({ state, commit }, country) {
    if (isEmpty(state.customerStoriesDetail) == false) {
      return
    }

    return customerStoryService
      .getCustomerStoriesDetail$(country)
      .pipe(tap(customerStories => commit(types.SET_CUSTOMER_STORIES_DETAIL, customerStories)))
      .toPromise()
  }
}

export const customerStoryStore = {
  state,
  mutations,
  actions,
  namespace,
  types
}
